import type { ResourceProps } from 'react-admin';
import { CanAccess } from 'react-admin';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';

// const AsyncPageCreate = lazy(() => import('./create'));
// const AsyncPageEdit = lazy(() => import('./edit'));
const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.paymentCards} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  // create: AsyncPageCreate as ComponentType<any>,
  // edit: AsyncPageEdit as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  icon: CreditCardIcon as ComponentType<any>,
} as ResourceProps;
